<template lang="pug">
  a.button.is-green(v-if="!conversionCompleted" :disabled="disabled"
                    :class="{ 'is-loading': conversionInProgress }" @click="$emit('startConversion')")
    b-icon(icon="chevron-circle-right")
    span {{ $t('Start Conversion') }}
  a.button.is-green(v-else-if="!downloadUrl2 || !downloadName2" :href="resultUrl" :download="resultName" @click="$emit('download')")
    b-icon(icon="download")
    span
      slot {{ $t('Download Template') }}
  .buttons.has-addons(v-else)
    a.button.is-green(:href="resultUrl" :download="resultName" @click="$emit('download')")
      b-icon(icon="download")
      span
        slot {{ $t('Download Template') }}
    a.button.is-yellow(:href="downloadUrl2" :download="downloadName2" @click="$emit('download2')")
      b-icon(icon="download")
      span
        slot(name="download2") {{ $t('Download User Master Data') }}
</template>

<script>
export default {
  name: 'ConvertDownloadButton',
  props: {
    conversionInProgress: {
      type: Boolean,
      required: true
    },
    conversionCompleted: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    downloadUrl: {
      type: String,
      required: true
    },
    downloadName: {
      type: String,
      required: true
    },
    downloadUrl2: {
      type: String
    },
    downloadName2: {
      type: String
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ConvertDownloadButton.vue